module.exports = __webpack_public_path__ + "static/media/60ad.763d0a7a.gif";